const IOS_DEVICE = /iPad|iPhone|iPod/i
const SAFARI_ENGINE = /AppleWebKit/i
const IOS_CHROME = /CriOS/i
const ALTERNATE_IOS_BROWSER = /CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo/i

function isIOS(input: Pick<Navigator, "userAgent" | "platform" | "maxTouchPoints">) {
  return IOS_DEVICE.test(input.userAgent) || (input.platform === "MacIntel" && input.maxTouchPoints > 1)
}

export function isIOSSafari(input: Pick<Navigator, "userAgent" | "platform" | "maxTouchPoints">) {
  return isIOS(input) && SAFARI_ENGINE.test(input.userAgent) && !ALTERNATE_IOS_BROWSER.test(input.userAgent)
}

export function isIOSChrome(input: Pick<Navigator, "userAgent" | "platform" | "maxTouchPoints">) {
  return isIOS(input) && SAFARI_ENGINE.test(input.userAgent) && IOS_CHROME.test(input.userAgent)
}

export function applyIOSBrowserViewportConstraints(document: Document, navigator: Navigator) {
  const safari = isIOSSafari(navigator)
  const chrome = isIOSChrome(navigator)
  if (!safari && !chrome) return false

  document.documentElement.toggleAttribute("data-ios-safari", safari)
  document.documentElement.toggleAttribute("data-ios-chrome", chrome)
  const viewport = document.querySelector<HTMLMetaElement>('meta[name="viewport"]')
  if (!viewport) return false
  if (/(?:^|,)\s*maximum-scale\s*=/.test(viewport.content)) return true
  viewport.content = `${viewport.content}, maximum-scale=1`
  return true
}
